<template>
  <div class="purchase-history-page">
    <div class="page-header">
      <h1>
        <svg class="title-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        购买历史
      </h1>
      <p>查看你的金币充值、VIP 开通等购买记录</p>
    </div>

    <div v-if="loading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <div v-else-if="purchases.length === 0" class="empty-state">
      <svg class="empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
      <p>暂无购买记录</p>
      <button @click="goRecharge" class="btn-primary">去充值</button>
    </div>

    <div v-else class="purchase-list">
      <div v-for="item in purchases" :key="item.id" class="purchase-card">
        <div class="purchase-main">
          <div class="purchase-icon" :class="item.type">
            <svg v-if="item.type === 'coin'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v10M9.5 9.5h3.5a1.5 1.5 0 0 1 0 3h-2a1.5 1.5 0 0 0 0 3H14"/></svg>
            <svg v-else-if="item.type === 'vip'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7l4 5 5-7 5 7 4-5v11H3z"/></svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
          </div>
          <div class="purchase-info">
            <div class="purchase-title">{{ item.title }}</div>
            <div class="purchase-meta">
              <span class="purchase-type">{{ item.type_text }}</span>
              <span class="purchase-time">{{ item.createtime_text }}</span>
            </div>
          </div>
        </div>
        <div class="purchase-side">
          <div class="purchase-amount">¥{{ item.amount }}</div>
          <div class="purchase-status" :class="item.status">{{ item.status_text }}</div>
        </div>
      </div>
    </div>

    <div v-if="purchases.length > 0 && hasMore" class="load-more">
      <button @click="loadMore" class="btn-primary" :disabled="loadingMore">
        {{ loadingMore ? '加载中...' : '加载更多' }}
      </button>
    </div>
  </div>
</template>

<script>
import { getPurchaseHistory } from '../api/index';

export default {
  name: 'PurchaseHistoryPage',
  data() {
    return {
      loading: true,
      loadingMore: false,
      purchases: [],
      page: 1,
      limit: 20,
      total: 0
    };
  },
  computed: {
    hasMore() {
      return this.purchases.length < this.total;
    }
  },
  mounted() {
    this.loadPurchases();
  },
  methods: {
    async loadPurchases() {
      this.loading = true;
      try {
        const res = await getPurchaseHistory({ page: this.page, limit: this.limit });
        if (res.data && res.data.code === 1) {
          this.purchases = res.data.data.list || [];
          this.total = res.data.data.total || 0;
        }
      } catch (e) {
        console.error('加载购买历史失败:', e);
      } finally {
        this.loading = false;
      }
    },
    async loadMore() {
      if (this.loadingMore || !this.hasMore) return;
      this.loadingMore = true;
      this.page++;
      try {
        const res = await getPurchaseHistory({ page: this.page, limit: this.limit });
        if (res.data && res.data.code === 1) {
          const list = res.data.data.list || [];
          this.purchases = [...this.purchases, ...list];
        }
      } catch (e) {
        console.error('加载更多购买历史失败:', e);
      } finally {
        this.loadingMore = false;
      }
    },
    goRecharge() {
      this.$router.push('/coins');
    }
  }
};
</script>

<style scoped>
.purchase-history-page {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--text);
}

.page-header {
  text-align: center;
  margin-bottom: 24px;
  padding: 22px 24px;
  background: linear-gradient(135deg, var(--brand-deep) 0%, var(--brand) 100%);
  color: #fff;
  border-radius: 8px;
}

.page-header h1 {
  margin: 0 0 8px 0;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.page-header p {
  margin: 0;
  opacity: 0.9;
  font-size: 13px;
}

.title-svg {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.loading-state,
.empty-state {
  text-align: center;
  padding: 50px 20px;
  color: var(--text-dim);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--surface-3);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.purchase-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.purchase-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  padding: 14px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: border-color 0.2s;
}

.purchase-card:hover {
  border-color: var(--border-strong);
}

.purchase-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.purchase-icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--surface-3);
  color: var(--text-dim);
}

.purchase-icon svg {
  width: 22px;
  height: 22px;
}

.purchase-icon.coin {
  background: rgba(251, 191, 36, 0.16);
  color: #fbbf24;
}

.purchase-icon.vip {
  background: rgba(251, 191, 36, 0.16);
  color: #fbbf24;
}

.purchase-icon.chapter {
  background: rgba(79, 172, 254, 0.16);
  color: #7dd3fc;
}

.purchase-info {
  min-width: 0;
}

.purchase-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.purchase-meta {
  display: flex;
  gap: 8px;
  font-size: 12px;
  color: var(--text-faint);
}

.purchase-type {
  background: var(--brand-soft);
  color: #bfe3ff;
  padding: 1px 8px;
  border-radius: 99px;
}

.purchase-side {
  text-align: right;
  flex-shrink: 0;
}

.purchase-amount {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 4px;
}

.purchase-status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 99px;
  display: inline-block;
}

.purchase-status.success {
  background: rgba(52, 211, 153, 0.16);
  color: #34d399;
}

.purchase-status.pending {
  background: rgba(251, 191, 36, 0.16);
  color: #fbbf24;
}

.purchase-status.failed {
  background: rgba(248, 113, 113, 0.16);
  color: #f87171;
}

.load-more {
  text-align: center;
  margin-top: 20px;
}

.btn-primary {
  background: var(--brand);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover:not(:disabled) {
  background: var(--brand-hover);
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .purchase-history-page {
    margin: 10px;
    padding: 15px;
  }

  .purchase-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .purchase-side {
    text-align: left;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
